import { render, staticRenderFns } from "./PlatformHotspotList.vue?vue&type=template&id=2ca27025&scoped=true&"
import script from "./PlatformHotspotList.vue?vue&type=script&lang=js&"
export * from "./PlatformHotspotList.vue?vue&type=script&lang=js&"
import style0 from "./PlatformHotspotList.vue?vue&type=style&index=0&id=2ca27025&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca27025",
  null
  
)

export default component.exports